export default "__VITE_ASSET__KVIFDSyj__"